import { GROUPS } from "@/utils/constants/groups.js";
import { getObjetIndexByKey } from "@/utils/helpers/array.js";

function getGroupByKeyValue(key, value) {
    const groupIndex = getObjetIndexByKey(GROUPS, key, value);
    if (groupIndex != -1) {
        return GROUPS[groupIndex];
    }

    return undefined;
}

export function getGroupTypeName(index) {
    const group = getGroupByKeyValue("id_group_type", parseInt(index));

    if (group) {
        return group.group_type_name;
    }

    return undefined;
}

export function getGroupTypeColor(index) {
    const group = getGroupByKeyValue("id_group_type", parseInt(index));

    if (group) {
        return group.color;
    }

    return undefined;
}